import Service from "./apiService";

class FilesService extends Service {

  getFiles(type, id, id2) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `files/get/${type}/${id}/${id2}`,
      method: "GET",
    });
  }

  setFiles(type, id, id2, data) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `files/set/${type}/${id}/${id2}`,
      method: "POST",
      body: super.getFormData(data),
    });
  }

  downloadFile(type, fileId) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `files/download/${type}/${fileId}`,
      method: "GET",
      responseType: 'blob',
    });
  }

  openFile(type, fileId) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `files/open/${type}/${fileId}`,
      method: "GET",
      responseType: 'blob',
    });
  }

}

export var filesService = new FilesService();
